import styled from '@emotion/styled';

const IntroductionPageStyle = styled('div')`
    line-height: 1.4;
    font-size: 16px;
    .text-signature {
        font-family: 'The Nautigal', cursive;
        font-size: 44.196px;
        font-weight: 400;
        line-height: 44.196px;
    }
    .color-success {
        color: rgb(18, 184, 151);
    }
    .text-line {
        text-decoration-line: underline;
    }

    .intro-title {
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 24px;
    }
    .box-line {
        margin-bottom: 24px;
        border-bottom: 1px solid rgb(220, 220, 220);
        padding-bottom: 48px;
    }
    .box-intro {
        border-radius: 8px;
        border: 1px solid rgb(220, 220, 220);
        background: rgb(255, 255, 255);
        padding: 32px;
        color: rgb(79, 79, 79);
        margin-bottom: 36px;

        .m-bottom {
            margin-bottom: 20px;
        }

        .info-seller {
            display: flex;
            justify-content: space-between;
            align-items: end;
            text-align: right;
            font-weight: 900;
        }
    }

    .box-about {
        .consultant {
            text-align: right;
            font-weight: 900;
        }

        .detail {
            margin-bottom: 16px;
        }
    }

    .ready-book {
        padding: 30px;
        background: rgb(240, 255, 254);
        margin-bottom: 40px;
        margin-top: 20px;
        font-size: 16px;

        .title-ready {
            color: rgb(0, 0, 0);
            font-size: 24px;
            font-weight: 900;
        }

        .btn-pay {
            background-color: rgb(18, 184, 151) !important;
            width: 100%;
            height: 56px;
            font-weight: 900;
            font-size: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            color: #fff;
            margin: 16px 0;
            padding: 10px;
            text-align: center;
        }
    }

    .box-cart {
        background-color: rgb(255, 255, 255);
        border-radius: 8px;
        box-shadow: rgba(156, 171, 194, 0.4) 4px 4px 20px 0px;
        padding: 2rem;
        position: relative;
        margin-bottom: 24px;
        color: rgb(0, 0, 0);

        .title {
            font-size: 24px;
            font-weight: 700;
        }
        .sub-title {
            font-size: 20px;
            font-weight: 700;
            margin: 16px 0;
        }

        .group {
            display: none;
        }

        .viewPayment {
            font-size: 18px;
        }

        &.edit {
            border: 2px solid rgb(18, 184, 151);
            padding: 16px;
        }

        .iconAddComment {
            position: absolute;
            right: 0;
            top: 50%;
            margin-right: -25px;
            margin-top: -25px;
            cursor: pointer;
            transition: all 0.2s;
            z-index: 5;
            &:hover {
                transform: scale(1.1);
            }
        }
    }

    @media screen and (min-width: 992px) {
        .max-w {
            width: calc(100% - 100px);
        }
    }

    @media screen and (max-width: 767px) {
        .box-intro {
            .info-seller {
                flex-direction: column;
            }
        }
    }

    @media print {
        .box-intro,
        .box-line,
        .box-about {
            break-inside: avoid;
            page-break-inside: avoid;
            margin-top: 24px;
        }
    }
`;
export default IntroductionPageStyle;
